module.exports = __webpack_public_path__ + "5e6dd9ce2e92ac25c3296bb3cd30c4c9.svg";